
import Snow from './Video/Snow.mp4';
import MornSnow from './Video/MornSnow.mp4';
import Sunny from './Video/Sunny.mp4';
import ClearNight from './Video/clearNight.mp4';
import ClearDay from './Video/ClearDay.mp4';
import NightCloud from './Video/NightCloud.mp4';
import DayCloud from './Video/DayCloud.mp4';
import DayRain from './Video/DayRain.mp4';
import Mist from './Video/Mist.mp4';
import Overcast from './Video/Overcast.mp4';
import Default from './Video/Default.mp4';

import './Background.css';
function Background(props) {
    let source='';
    if (((props.weatherData.data.current.condition.text).toLowerCase().includes ('snow')) && props.weatherData.data.current.is_day===1) {
        source=MornSnow;
    }else if (((props.weatherData.data.current.condition.text).toLowerCase().includes ('snow')) && props.weatherData.data.current.is_day===0) {
        source=Snow;
    } else if (((props.weatherData.data.current.condition.text).toLowerCase().includes ('clear')) && props.weatherData.data.current.is_day===0) {
        source=ClearNight;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('clear')) && props.weatherData.data.current.is_day===1){
        source=ClearDay;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('cloud')) && props.weatherData.data.current.is_day===1){
        source=DayCloud;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('cloud')) && props.weatherData.data.current.is_day===0){
        source=NightCloud;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('rain')) || (props.weatherData.data.current.condition.text).toLowerCase().includes ('drizzle')){
        source=DayRain;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('sunny'))){
        source=Sunny;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('mist'))){
        source=Mist;
    }else if(((props.weatherData.data.current.condition.text).toLowerCase().includes ('overcast'))){
        source=Overcast;
    }else{
        source=Default;
    }
    
    console.log(props.weatherData.data.current.condition.text)
    return (
        <div className="banner">
            <video key={source} autoPlay muted loop>
                <source src= {source} type="video/mp4"/>
            </video>
            
        </div>
    )
}

export default Background;
